import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { concat, debounce } from 'lodash';
import Multiselect from 'multiselect-react-dropdown';
import APIService from '../../shared/services/api';
import Notify from '../../shared/notify';
import List from '@shared/component/List';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { NavLink } from 'react-router-dom';
import DropDown from '@shared/component/DropDown';
import CustomDateTimePicker from '@shared/component/DatePicker';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import { MdDeleteOutline } from 'react-icons/md';
import { IoMdAdd } from 'react-icons/io';
import FilterModule from '../filterModel/filter';
import BidListing from './bid_modal'

import { useLocalStorage } from '@shared/auth/useLocalStorage';
import { ActionValues, DateFormatPicker, actionsPermissionValidator, imageCompress } from '@utils/static/commonUtils';
import Lists from '@shared/component/Lists';
import { TbRecycleOff } from 'react-icons/tb';

import { DemandAddMidLocation } from './demandAddMidLocation';



export function Demand_transporter() {
    const date = new Date();
    const newDate24 = new Date(date);
    const newDate48 = new Date(newDate24);
    const newDate72 = new Date(newDate48);

    newDate24.setTime(date.getTime() + 2 * 60 * 60 * 1000);
    newDate48.setTime(date.getTime() + 4 * 60 * 60 * 1000);
    newDate72.setTime(date.getTime() + 6 * 60 * 60 * 1000);

    const [isToggled, setIsToggled] = useState(true);
    const [errors, setError] = useState<any>({
        bidType: {
            required: false,
            error: false,
        },

        fromLocationId: {
            required: true,
            error: true,
            message: 'Please select pickup',
        },
        toLocationId: {
            required: true,
            error: true,
            message: 'Please select drop',
        },
        pickUpDate: {
            required: true,
            error: true,
            message: 'Please select date',
            min: newDate48,
        },
        deliveryDate: {
            required: true,
            error: true,
            message: 'Please select date',
            min: newDate72,
        },
        materialType: {
            required: true,
            error: true,
            message: 'Please select',
        },
        cutOffTime: {
            required: true,
            error: true,
            message: 'Please select date',
            min: newDate24,
        },
        itemUnit: {
            required: true,
            error: true,
            message: 'Please select unit    ',
        },
        weight: {
            required: true,
            error: true,
            message: 'Please enter weight',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 6,
        },
        minBidRate: {
            required: false,
            error: false,
            message: 'Please enter min bid',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 6,
        },
        maxBidRate: {
            required: false,
            error: false,
            message: 'Please enter max bid',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 6,
        },
        noOfVehicles: {
            required: true,
            error: true,
            message: 'Please enter vehicle no',
            // pattern: /^[a-zA-Z0-9]+$/,
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/, //pattern: /^\d+$/,
            maxLength: 3,
        },
        userIds: {
            required: true,
            error: true,
            message: 'Please select user',
        },
        description: {
            required: false,
            error: false,
            message: 'Please enter description',
        },
    });

    const listRef: any = useRef(null);
    const [userError, setUserError] = useState(false);

    const { setLoader, demandStatus }: any = useContext(AuthContext);

    const { getStorageItem }: any = useLocalStorage();
    const user = getStorageItem('user') ? JSON.parse(getStorageItem('user')) : false;
    const [statusCompleted, setStatusCompleted] = useState('');
    const [Demand_transporter, setDemand_transporter] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isSubmit, setIsSubmit] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [editItemId, setEditItemId] = useState(null);
    const [checkData, setCheckData] = useState([]);
    const [disabledPickup, setDisabledPickup] = useState(true);
    const [disabledDeliveryDate, setDisabledDeliveryDate] = useState(true);
    const [filterLocation, setFilterLocation] = useState([]);
    const [showFilterDemand, setShowFilterDemand] = useState(false);
    const [showBidListingModal, setShowBidListingModal] = useState(false)
    const [demandId, setDemandId] = useState<string | null>(null);


    const [demandTransporter, setDemandTransporter] = useState<any>({
        bidType: user?.demandType == 'both' ? 'manual' : 'auto',
        // categoryId: null,
        fromLocationId: null,
        toLocationId: null,
        midLocationId: [{ value: 0, index: 0, key: 1, id: Date.now() }],
        pickUpDate: null,
        deliveryDate: null,
        cutOffTime: null,
        materialType: null,
        itemUnit: null,
        weight: null,
        minBidRate: '',
        maxBidRate: '',
        noOfVehicles: null,
        isMaxAndMinOptional: true,
        userIds: [],
        description: '',
        sample: null,
    });
    const [editDemandTransporter, setEditDemandTransporter] = useState<any>({
        bidType: 'manual',
        // categoryId: null,
        fromLocationId: null,
        toLocationId: null,
        midLocationId: [],
        pickUpDate: null,
        deliveryDate: null,
        cutOffTime: null,
        materialType: null,
        itemUnit: null,
        weight: null,
        minBidRate: '',
        maxBidRate: '',
        noOfVehicles: null,
        app_users: null,
        userIds: [],
        isMaxAndMinOptional: false,
        midLocationIdArray: [],
        description: '',
        // pickupName: '',
        // deliveryName : '',
        // deliveryNo:null,
        // pickupNo:null,
        demandId: null,
        sample: null,
        sampleId: null,
    });
    const [transporter, setTransporter] = useState([]);
    // const [file, setFile] = useState(null);
    const [edit, setEdit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [itemtype, setItemtype] = useState('');
    const [minBidError, setminBidError] = useState(false);
    const [showList, setShowList] = useState(false);
    const [multiSelectComponents, setMultiSelectComponents] = useState<{ key: number; index: number }[]>([
        { key: 0, index: 0 },
    ]);
    const [midLocationArrayList, setMidLocationArrayList] = useState([]);
    const [existingState, setExistingState] = useState({});

    const [unit, setunit] = useState([
        {
            name: 'mass',
            data: ['Milligram', 'Gram', 'Pound', 'Kilogram', 'Metric Ton'],
        },
        {
            name: 'volume',
            data: ['Milliliter', 'Litre', 'Cubic Meter'],
        },
        {
            name: 'Fmcg',
            data: ['Milligram', 'Gram', 'Pound', 'Kilogram', 'Metric Ton'],
        },
    ]);
    const [materialData, setMaterialData] = useState([
        {
            key: 'mass',
            name: 'Solid',
        },
        {
            key: 'volume',
            name: 'Liquid/Gas',
        },
        {
            key: 'Fmcg',
            name: 'FMCG Goods',
        },
    ]);
    const [disableUpdateBtn, setDisableUpdateBtn] = useState(false);

    const [showHideModel, setShowHideModel] = useState(false);
    const [columns, setColumns] = useState({
        id: 'Demand Id',
        bidType: 'Demand Type',
        app_users: 'Transporter Name',
        pickUpDate: 'Pick Up Date & Time',
        'from.city': 'Pick Up From',
        // 'mid.city': 'In Between Stop',
        'to.city': 'Deliver To',
        deliveryDate: 'Delivery Date & Time',
        createdAt: 'Created Date',
        status: 'Status',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
            actionsPermissionValidator(location.pathname, ActionValues.View) ||
            actionsPermissionValidator('/home/bids/transporter', ActionValues.View)
            ? { demandTransporterAction: 'Action' }
            : null),
        // demandTransporterAction: 'Action',
    });

    const addMultiSelect = () => {
        try {
            const t: any = JSON.parse(JSON.stringify(edit ? editDemandTransporter : demandTransporter));
            t.midLocationId.push({
                value: t.midLocationId.length,
                key: t.midLocationId.length,
                index: t.midLocationId.length,
                id: Date.now(),
            });

            if (edit) {
                setEditDemandTransporter(t);
            } else {
                setDemandTransporter(t);
            }
        } catch (error) {
            //console.log('error', error);
        }
    };

    const removeMultiSelect = (id, index) => {
        const dp = JSON.parse(JSON.stringify(edit ? editDemandTransporter : demandTransporter));

        const newMidLoc = [...dp.midLocationId];
        const removedItem = newMidLoc[index];

        dp['midLocationId'] = newMidLoc.filter(location => location.id !== id);

        // newMidLoc.splice(index, 1);
        // dp['midLocationId'] = newMidLoc;

        if (edit) {
            setEditDemandTransporter(dp);
        } else {
            setDemandTransporter(dp);
        }

        addLocation(removedItem?.value || null);
    };

    const renderMultiSelect = (key, index) => (
        <div className="row" key={index}>
            {' '}
            <div className="col-sm-6">
                {JSON.stringify(key)}
                <MultiSelect
                    isSingle={true}
                    options={locationData}
                    placeholder={'In Between Stop'}
                    getMultiSelectValue={e => getValueMidLocation(e, index)}
                    displayName="fullcity"
                    displayValue="id"
                    isClearable={!edit}
                    notSelectDefault={true}
                    isDisabled={statusCompleted === 'completed'}
                    setSelectedValues={
                        edit && editDemandTransporter?.midLocationIdArray
                            ? editDemandTransporter?.midLocationIdArray[index] || null
                            : null
                    }
                />
            </div>
            <div className="col-sm-6">
                {index > 0 ? (
                    statusCompleted == 'completed' ? (
                        ''
                    ) : (
                        <Button variant="" onClick={() => removeMultiSelect(key, index)} className="ml-2">
                            <MdDeleteOutline size={25} />
                        </Button>
                    )
                ) : statusCompleted == 'completed' ? (
                    ''
                ) : (
                    <Button variant="secondary" size="sm" onClick={addMultiSelect}>
                        <IoMdAdd /> Add
                    </Button>
                )}
            </div>
        </div>
    );

    const removeLocation = value => {
        try {
            const datCheck = [...locationData];
            const locationFilter = datCheck?.filter((data: any) => data?.id != value);

            setLocationData(locationFilter);
        } catch (error) { }
    };

    const addLocation = id => {
        try {
            if (!id) {
                return;
            }
            const dCopyList = JSON.parse(JSON.stringify(locationData));
            const findPickLocId = filterLocation.find((data: any) => data.id === id);
            dCopyList.push(findPickLocId);

            setLocationData(dCopyList);
        } catch (error) { }
    };

    const getValue = (e: any) => {
        try {
            const minBid = edit ? editDemandTransporter.minBidRate : demandTransporter?.minBidRate;
            if (isSubmit && e?.maxBidRate && minBid && parseInt(e?.maxBidRate) > parseInt(minBid)) {
                setminBidError(false);
            }

            if (edit) {
                const data = { ...editDemandTransporter, ...e };
                setEditDemandTransporter(data);
            } else {
                if (e?.cutOffTime) {
                    setDisabledPickup(false);
                }
                if (e?.pickUpDate) {
                    setDisabledDeliveryDate(false);
                }

                const data = { ...demandTransporter, ...e };

                setDemandTransporter(data);
                handleLocationDataUpdate(data);
            }
        } catch (error) {
            setLoader(false);
        }
    };

    const getValueMidLocation = (e, key) => {
        try {
            if (edit) {
                const d: any = JSON.parse(JSON.stringify(edit ? editDemandTransporter : demandTransporter));
                const newMidLocationId: any = [...d.midLocationId];

                const newLocation = { value: e.value, key, label: e.label, id: newMidLocationId[key].id };
                newMidLocationId[key] = newLocation;
                d['midLocationId'] = newMidLocationId;

                handleLocationDataUpdate(d);
                setEditDemandTransporter(d);
            } else if (e?.value) {
                const d: any = JSON.parse(JSON.stringify(demandTransporter));
                const newMidLocationId: any = [...d.midLocationId];

                const newLocation = { value: e.value, key, label: e.label, id: newMidLocationId[key].id };
                newMidLocationId[key] = newLocation;
                d['midLocationId'] = newMidLocationId;
                ////console.log('----', d);

                handleLocationDataUpdate(d);
                setDemandTransporter(d);
            }
        } catch (error) {
            setLoader(false);
        }
    };

    const handlefile = async (files: FileList | null, e: any) => {
        if (files && files.length > 0) {
            const fileObj = files[0];

            // Check file size (3MB limit)
            const maxSize = 5 * 1024 * 1024; // 3MB in bytes
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!allowedTypes.includes(fileObj.type)) {
                Notify('error', 'Invalid file format. Please choose a JPG, JPEG, PNG, or PDF file.');
                e.target.value = null;
                return;
            }
            if (fileObj.size > maxSize) {
                Notify('error', 'File size must be less than 5 mb');
                e.target.value = null;
                return;
            }

            const file: any = await imageCompress(fileObj);

            // Handle the file based on its type
            if (file.type.startsWith('image/')) {
                // If it's an image, update the preview
                const reader = new FileReader();
                reader.onload = (e: ProgressEvent<FileReader>) => {
                    if (edit) {
                        setEditDemandTransporter({
                            ...editDemandTransporter,
                            sample: file.name,
                            file: file,
                            imageUrl: e.target?.result as string,
                        });
                    }

                    setDemandTransporter({
                        ...demandTransporter,
                        sample: file.name,
                        file: file,
                        imageUrl: e.target?.result as string,
                    });
                };
                reader.readAsDataURL(file);
            } else {
                // If it's not an image, handle it accordingly
                if (edit) {
                    setEditDemandTransporter({
                        ...editDemandTransporter,
                        sample: file.name,
                        file: file,
                        imageUrl: 'pdf',
                    });
                }

                setDemandTransporter({ ...demandTransporter, sample: file.name, file: file, imageUrl: 'pdf' });
            }
        }
    };

    const editVendor = (data: any) => {
        const d = data.map((i: any) => {
            return { id: i.id, name: i.name };
        });

        setEditDemandTransporter({ ...editDemandTransporter, userIds: d });
        // setUserError(d.length ? false : userError);
    };

    const getLocation = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('location/?page=1&sort=createdAt&type=active', true, false);
            setLoader(false);
            setLocationData(data?.data?.data);
            setFilterLocation(data?.data?.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getTransporter = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll(
                'user/get/allTransporterUser/?sort=createdAt&type=active',
                true,
                false,
            );
            setLoader(false);
            setTransporter(data?.data?.data || []);
        } catch (err) {
            setLoader(false);
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            let data;
            if (value) {
                data = await APIService.getAll(
                    `demand/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                    true,
                    false,
                );
            } else {
                data = await APIService.getAll(`demand?page=${page}&sort=createdAt`, true, false);
            }

            setLoader(false);
            setRecordCount(data.data.count);
            setDemand_transporter(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getDemand_transporter = async (page: any = 1) => {
        try {
            setCurrentPage(page);
            setLoader(true);
            const data = await APIService.getAll(`demand?page=${page}&sort=createdAt`, true, false);
            setLoader(false);
            setRecordCount(data?.data?.count || 0);
            setDemand_transporter(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const handleEdit = async (itemId: any) => {
        const d1: any = Demand_transporter?.find((item: any) => item.id === itemId);

        setDisableUpdateBtn(d1?.bids?.length > 0 ? true : false);

        const d = await APIService.getAll(`demand/${itemId}`, true, false);

        const finalData = d.data?.getAllData;

        if (finalData) {
            setStatusCompleted(finalData?.status);

            // setMidLocationArrayList(finalData?.midLocationIdArray);
            // const itemToEdit = JSON.parse(JSON.stringify(d));
            // for (let i = 1; i < finalData?.midLocationIdArray?.length; i++) {
            //     addMultiSelect();
            // }

            setEditItemId(itemId);
            setEdit(true);
            const appUsers = (finalData?.app_users || []).filter(i => (i['isFixed'] = true));

            errors['fromLocationId']['error'] = false;
            errors['toLocationId']['error'] = false;
            errors['userIds']['error'] = false;

            if (finalData?.status == 'completed') {
                enableDisableField(true);
            } else {
                setError(errors);
            }

            setDisabledPickup(false);
            setDisabledDeliveryDate(false);
            //console.log('finalData', finalData);

            const dataObj = {
                ...finalData,
                cutOffTime: finalData.cutOffTime,
                deliveryDate: finalData.deliveryDate,
                pickUpDate: finalData.pickUpDate,
                locationData: {
                    label:
                        `${finalData?.from?.nickName ? `  ${finalData?.from?.nickName} -` : ''}${finalData?.from?.city
                        } (${finalData?.from?.pincode})` || '',
                    value: finalData?.fromLocationId || 0,
                },
                locationToData: {
                    label:
                        `${finalData?.to?.nickName ? `  ${finalData?.to?.nickName} -` : ''} ${finalData?.to?.city} (${finalData?.to?.pincode
                        })` || '',
                    value: finalData?.toLocationId || 0,
                },
                midLocationId: finalData?.midLocationIdArray?.length > 0 ? finalData?.midLocationIdArray : [],
                midLocationData: finalData?.midLocationId
                    ? {
                        label:
                            `${finalData?.mid?.nickName ? `  ${finalData?.mid?.nickName} -` : ''} ${finalData?.mid?.city
                            } (${finalData?.mid?.pincode})` || '',
                        value: finalData?.midLocationId || 0,
                        id: finalData?.midLocationId || 0,
                    }
                    : null,

                userIds: appUsers,
                ['imageUrl']:
                    finalData.sampleId != null
                        ? finalData.sampleId.split('.')[1] == 'jpeg' ||
                            finalData.sampleId.split('.')[1] == 'jpg' ||
                            finalData.sampleId.split('.')[1] == 'png'
                            ? process.env.REACT_APP_API_BASE + finalData.sampleId
                            : 'pdf'
                        : null,
            };
            setEditDemandTransporter(dataObj);
            handleLocationDataUpdate(dataObj);
            setShowHideModel(true);
            setIsToggled(finalData.isMaxAndMinOptional);
        }
    };

    useEffect(() => {
        getDemand_transporter();
        // getCategory();
        getLocation();
        getTransporter();
    }, []);

    const updateDemand = () => {
        getDemand_transporter();
    };

    useEffect(() => {
        if (demandStatus === 'transporter') {
            updateDemand();
        }
    }, [demandStatus]);

    const enableDisableField = flag => {
        try {
            errors['weight']['disabled'] = flag;
            errors['noOfVehicles']['disabled'] = flag;
            errors['maxBidRate']['disabled'] = flag;
            errors['minBidRate']['disabled'] = flag;
            errors['itemUnit']['disabled'] = flag;
            errors['materialType']['disabled'] = flag;
            errors['description']['disabled'] = flag;

            setError(errors);
        } catch (error) { }
    };

    const addDemand_transporter = async () => {
        try {
            const formData = new FormData();

            // console.log('demandTransporter', errors, demandTransporter);

            let isValid = await CheckValidator(errors, demandTransporter);

            // console.log('isValid', isValid);

            setIsSubmit(!isValid);

            if (demandTransporter.isMaxAndMinOptional == false) {
                if (
                    demandTransporter?.minBidRate &&
                    demandTransporter?.maxBidRate &&
                    parseInt(demandTransporter?.minBidRate) > parseInt(demandTransporter?.maxBidRate)
                ) {
                    isValid = false;
                    setminBidError(true);
                } else {
                    setminBidError(false);
                }
            }
            let filteredMidLocationId;
            if (demandTransporter?.midLocationId?.length > 0) {
                filteredMidLocationId = demandTransporter?.midLocationId.filter(item => item.hasOwnProperty('label'));
            }

            if (isValid) {
                const delivery = moment(new Date(demandTransporter.deliveryDate));
                const pickup = moment(new Date(demandTransporter.pickUpDate));
                const cutOff = moment(new Date(demandTransporter.cutOffTime));

                if (pickup.diff(cutOff, 'hour') < 2) {
                    Notify('error', 'Pickup time at least two hours greater  than cut off Time  time ');
                    return;
                }
                if (delivery != null && delivery.diff(pickup, 'hour') < 2) {
                    Notify('error', 'Delivery time  at least two hours greater than pick up date time');
                    return;
                }

                formData.append('bidType', demandTransporter.bidType);

                formData.append('fromLocationId', demandTransporter.fromLocationId);
                formData.append('toLocationId', demandTransporter.toLocationId);
                formData.append('pickUpDate', demandTransporter.pickUpDate);
                formData.append('deliveryDate', demandTransporter.deliveryDate);
                formData.append('weight', demandTransporter.weight);
                if (demandTransporter.isMaxAndMinOptional == false) {
                    formData.append('minBidRate', demandTransporter.minBidRate);
                    formData.append('maxBidRate', demandTransporter.maxBidRate);
                }

                formData.append('isMaxAndMinOptional', demandTransporter.isMaxAndMinOptional);
                formData.append('noOfVehicles', demandTransporter.noOfVehicles);
                formData.append('itemUnit', demandTransporter.itemUnit);
                formData.append('materialType', demandTransporter.materialType);
                formData.append('userIds', JSON.stringify(demandTransporter.userIds));
                formData.append('cutOffTime', demandTransporter.cutOffTime);
                if (demandTransporter?.description) {
                    formData.append('description', demandTransporter.description);
                }
                if (demandTransporter?.midLocationId) {
                    formData.append('midLocationId', JSON.stringify(filteredMidLocationId));
                }

                formData.append('sample', demandTransporter.file !== undefined ? demandTransporter.file : '');
                // return
                setLoader(true);
                const updateddata = await APIService.post('demand/', formData, true, true);
                setLoader(false);

                if (updateddata.status === 200) {
                    handelModel(false);
                    Notify('success', 'Demand created successfully');
                    clearObjData();
                    getDemand_transporter();
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            setLoader(true);
            const data = {
                status: status,
            };
            const updateddata = await APIService.update('demand/demandStatus', id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', ' Demand status updated successfully');
                // listRef.current.clearSearchBox(true);
                // getDemand_transporter(page);
                searchItem(search.trim(), page);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateDemand_transporter = async (id: any) => {
        try {
            const formData = new FormData();
            let isValid = await CheckValidator(errors, editDemandTransporter);

            if (isToggled == false) {
                if (
                    editDemandTransporter?.minBidRate &&
                    editDemandTransporter?.maxBidRate &&
                    parseInt(editDemandTransporter?.minBidRate) > parseInt(editDemandTransporter?.maxBidRate)
                ) {
                    isValid = false;
                    setminBidError(true);
                } else {
                    setminBidError(false);
                }
            }

            let filteredMidLocationId = [];
            if (editDemandTransporter?.midLocationId?.length > 0) {
                filteredMidLocationId = editDemandTransporter?.midLocationId?.filter(item =>
                    item.hasOwnProperty('label'),
                );
            }

            setIsSubmit(!isValid);

            if (isValid) {
                const delivery = moment(new Date(editDemandTransporter.deliveryDate));
                const pickup = moment(new Date(editDemandTransporter.pickUpDate));
                const cutOff = moment(new Date(editDemandTransporter.cutOffTime));

                if (
                    editDemandTransporter.cutOffTime &&
                    new Date(editDemandTransporter.cutOffTime).getTime() < newDate24.getTime()
                ) {
                    Notify('error', 'Please select a cutoff time that is at least two hours in the future');
                    return;
                }
                if (
                    editDemandTransporter.pickUpDate &&
                    new Date(editDemandTransporter.pickUpDate).getTime() < newDate48.getTime()
                ) {
                    Notify('error', 'Please select a pickup date time that is at least four hours in the future');
                    return;
                }

                if (
                    editDemandTransporter.deliveryDate &&
                    new Date(editDemandTransporter.deliveryDate).getTime() < newDate72.getTime()
                ) {
                    Notify('error', 'Please select a delivery date that is at least six hours in the future');
                    return;
                }

                if (pickup.diff(cutOff, 'hour') < 2) {
                    Notify('error', 'pickup time at least two hours greater than cutOffTime  time ');
                    return;
                }
                if (delivery != null && delivery.diff(pickup, 'hour') < 2) {
                    Notify('error', 'delivery time  at least two hours greater than pickUpdate time');
                    return;
                }
                if (editItemId) {
                    formData.append('bidType', editDemandTransporter.bidType);

                    formData.append('fromLocationId', editDemandTransporter.fromLocationId);
                    formData.append('toLocationId', editDemandTransporter.toLocationId);
                    formData.append('pickUpDate', editDemandTransporter.pickUpDate);
                    formData.append('deliveryDate', editDemandTransporter.deliveryDate);
                    formData.append('weight', editDemandTransporter.weight);
                    if (isToggled == false) {
                        formData.append('minBidRate', editDemandTransporter.minBidRate);
                        formData.append('maxBidRate', editDemandTransporter.maxBidRate);
                    }

                    formData.append('noOfVehicles', editDemandTransporter.noOfVehicles);
                    formData.append('itemUnit', editDemandTransporter.itemUnit);
                    formData.append('materialType', editDemandTransporter.materialType);
                    formData.append('userIds', JSON.stringify(editDemandTransporter.userIds));
                    formData.append('cutOffTime', editDemandTransporter.cutOffTime);
                    formData.append('isMaxAndMinOptional', editDemandTransporter.isMaxAndMinOptional);
                    if (editDemandTransporter?.description) {
                        formData.append('description', editDemandTransporter.description);
                    }
                    if (editDemandTransporter?.midLocationId) {
                        formData.append('midLocationId', JSON.stringify(filteredMidLocationId));
                    }

                    formData.append('demandId', editItemId);
                    formData.append(
                        'sample',
                        editDemandTransporter.file != undefined || editDemandTransporter.file != null
                            ? editDemandTransporter.file
                            : '',
                    );
                }
                setLoader(true);
                const updateddata = await APIService.update('demand', '', formData, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', ' Demand updated successfully');
                    handelModel(false);
                    setEdit(false);
                    getDemand_transporter(currentPage);
                    listRef.current.clearSearchBox(true);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getDeleteIds = async (ids: any) => {
        try {
            setLoader(true);
            const data = {
                ids: JSON.stringify(ids),
            };
            const updateddata = await APIService.post('demand/delete', data, true, true);
            setLoader(false);
            Notify('success', ' Demand deleted successfully');
            getDemand_transporter();
        } catch (error) {
            setLoader(false);
            getDemand_transporter();
        }
    };

    const clearObjData = () => {
        setDemandTransporter({
            bidType: 'manual',
            categoryId: null,
            fromLocationId: null,
            toLocationId: null,
            midLocationId: [{ value: 0, index: 0, key: 1, id: Date.now() }],
            pickUpDate: null,
            deliveryDate: null,
            cutOffTime: null,
            materialType: null,
            itemUnit: null,
            weight: null,
            minBidRate: null,
            maxBidRate: null,
            noOfVehicles: null,
            userIds: [],
            description: '',
            sample: null,
            imageUrl: null,
            isMaxAndMinOptional: true,
        });
        setIsToggled(true);
        setDisabledPickup(true);
        setDisabledDeliveryDate(true);
        setLocationData(filterLocation);
    };

    const clearEditObjData = () => {
        setEditDemandTransporter({
            bidType: 'manual',
            categoryId: null,
            fromLocationId: null,
            toLocationId: null,
            midLocationId: [],
            pickUpDate: null,
            deliveryDate: null,
            cutOffTime: null,
            materialType: null,
            itemUnit: null,
            weight: null,
            minBidRate: null,
            maxBidRate: null,
            noOfVehicles: null,
            app_users: null,
            userIds: [],
            description: '',
            demandId: null,
            sample: null,
            sampleId: null,
            imageUrl: null,
        });
        // setMultiSelectComponents([{ key: 0 }]);
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            if (edit) {
                clearEditObjData();
            }

            setUserError(false);
            if (!flag) {
                clearObjData();
            }
        } catch (error) { }
    };

    // filter model hide and show
    const handelFilterModal = (flag: boolean) => {
        try {
            setShowFilterDemand(flag);
        } catch (error) { }
    };

    const getMultiSelectValue = (e: any) => {
        try {
            if (e?.length > 0) {
                getValue({ userIds: e });
                demandTransporter['userIds'] = e;
                setDemandTransporter(demandTransporter);
                errors['userIds']['error'] = false;
            } else {
                demandTransporter['userIds'] = [];
                setDemandTransporter(demandTransporter);
                errors['userIds']['error'] = true;
            }

            setError(errors);
        } catch (error) { }
    };

    const bulkUpload = (e: any) => {
        try {
        } catch (error) { }
    };

    // get Data form props
    const handleSendData = (data, state) => {
        setExistingState(state);
        setRecordCount(data?.data?.count || 0);
        setDemand_transporter(data.data.data);
    };

    // handle Switch

    const handleSwitch = e => {
        const isChecked = e.target.checked;

        setIsToggled(isChecked);
        if (edit) {
            setEditDemandTransporter({
                ...editDemandTransporter,
                isMaxAndMinOptional: isChecked,
                maxBidRate: '',
                minBidRate: '',
            });
        } else {
            setDemandTransporter({
                ...demandTransporter,
                isMaxAndMinOptional: isChecked,
                maxBidRate: '',
                minBidRate: '',
            });
        }

        const errorsObj: any = {
            ...errors,
            minBidRate: {
                ...errors.minBidRate,
                required: !isChecked,
                error: !isChecked,
                readOnly: isChecked,
            },
            maxBidRate: {
                ...errors.maxBidRate,
                required: !isChecked,
                error: !isChecked,
                readOnly: isChecked,
            },
        };

        ////////console.log('errorsObj', errorsObj);

        setError(errorsObj);
    };

    // const filterPassedTime = time => {
    //     const currentDate = new Date();
    //     const selectedDate = new Date(time);

    //     // Add 2 hours (2 * 60 * 60 * 1000 milliseconds) to the current time
    //     const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);

    //     return twoHoursLater.getTime() < selectedDate.getTime();
    // };
    // filter pickupDate

    const filterPickUpTime = (cutOffTime, pickUpTime) => {
        const cutOffDate = new Date(cutOffTime);
        const selectedPickUpDate = new Date(pickUpTime);

        // Add 2 hours to the cutOffDate
        const twoHoursAfterCutOff = new Date(cutOffDate.getTime() + 2 * 60 * 60 * 1000);

        return twoHoursAfterCutOff.getTime() < selectedPickUpDate.getTime();
    };

    // filter Delivery Date

    const filterPickUpPassedTime = (pickUpTime, deliveryTime) => {
        const pickUpDate = new Date(pickUpTime);
        const selectedDeliveryDate = new Date(deliveryTime);

        // Add 2 hours to the pickUpDate
        const twoHoursAfterPickUp = new Date(pickUpDate.getTime() + 2 * 60 * 60 * 1000);

        return twoHoursAfterPickUp.getTime() < selectedDeliveryDate.getTime();
    };

    const handleShowList = data => {
        setCheckData(data);
        setShowList(true);
    };

    // push location after remove
    const handleLocationDataUpdate = data => {
        try {
            let locationIds: any = [];

            if (data?.fromLocationId || data?.toLocationId || data?.midLocationId?.length > 0) {
                // ////console.log('data', data);
                if (data?.fromLocationId) {
                    locationIds.push(data.fromLocationId);
                }
                if (data?.toLocationId) {
                    locationIds.push(data.toLocationId);
                }
                if (data?.midLocationId?.length) {
                    const d = data?.midLocationId.map(i => i.value);
                    locationIds = concat(locationIds, d);
                }

                // ////console.log('locationIds', locationIds);
                const findPickLocId = filterLocation.filter((data: any) => !locationIds.includes(data.id));
                ////console.log('findPickLocId', findPickLocId, demandTransporter);

                setLocationData(findPickLocId);
            }
        } catch (error) {
            ////console.log('error--', error);
        }
    };

    const filterPassedTime = (time, type) => {
        try {
            const cdate = moment();
            const selectedDate = new Date(time);
            const cutOffDate = moment();

            const dmdData = edit ? editDemandTransporter : demandTransporter;

            const currentDate = new Date();
            if (type == 'cutoff_date') {
                const selectedDate = new Date(time);
                // Add 2 hours (2 * 60 * 60 * 1000 milliseconds) to the current time
                const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
                return twoHoursLater.getTime() < selectedDate.getTime();
            } else if (type == 'pickup_date') {
                const currentDate = new Date(dmdData?.cutOffTime);
                const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
                return twoHoursLater.getTime() < selectedDate.getTime();
            } else if (type == 'delivery_date') {
                const currentDate = new Date(dmdData?.pickUpDate);
                const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
                return twoHoursLater.getTime() < selectedDate.getTime();
            }
        } catch (error) { }
    };

    const handleBidModal = (value: boolean) => {
        setShowBidListingModal(value)
    }

    // handleDemandId will call setDemandId internally
    const handleDemandId = (value: any) => {
        setDemandId(value);
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>
                            <NavLink to="/home/demands">Manage Demands</NavLink>
                        </li>
                        <li>Transporter</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={Demand_transporter}
                        searchItem={searchItem}
                        getById={handleEdit}
                        type={'add+delete'}
                        from={'transporter'}
                        getDeleteIds={getDeleteIds}
                        updateStatus={updateStatus}
                        addUpdateText="Demand"
                        handelModel={(e: boolean) => handelModel(e)}
                        handleBidListingModal={(e: boolean) => handleBidModal(e)}
                        bulkUpload={(e: boolean) => bulkUpload(e)}
                        handelFilterModal={(e: boolean) => handelFilterModal(e)}
                        callPagination={getDemand_transporter}
                        recordCount={recordCount}
                        locationData={locationData}
                        showList={handleShowList}
                        sendData={data => handleShowList(data)}
                        filterText="Filter"
                        userData={transporter}
                        demandType={user?.demandType}
                        helperText={'Search By City,Demand Type, Demand Id'}
                        showFilterButton={true}
                        filterDataObj={existingState}
                        handleDemandId={(e: any) => handleDemandId(e)}
                    />
                </div>

            </div>

            {showBidListingModal && (
                <BidListing
                    handleModal={handleBidModal}
                    demandId={demandId}

                />
            )}

            {showFilterDemand && (
                <FilterModule
                    handelFilterModal={(e: boolean) => handelFilterModal(e)}
                    locationData={filterLocation}
                    checkData={existingState}
                    sendData={(data, state) => handleSendData(data, state)}
                    getDemand_transporter={getDemand_transporter}
                />
            )}

            {showList && (
                <Modal scrollable={true} show={true} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton onClick={() => setShowList(false)}>
                        <Modal.Title>Transporter Name</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="model">
                            <div className="text_box">
                                <p style={{ textTransform: 'capitalize' }}>
                                    {checkData.map((person: any) => person?.name).join(', ')}
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}

            {showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    onHide={() => {
                        try {
                            handelModel(false);
                            setStatusCompleted('');
                            setEdit(false);
                            enableDisableField(false);
                            setDisableUpdateBtn(false);
                        } catch (error) { }
                    }}
                    backdrop="static"
                    keyboard={false}
                    size={'lg'}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {' '}
                            {statusCompleted == 'completed' ? 'View Demand' : edit ? 'Update Demand' : 'Add Demand'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    {user?.demandType == 'both' && (
                                        <>
                                            <div className="field_box">
                                                <h3>Bidding Type</h3>
                                                <div className="check_field_box mb-4">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault1"
                                                            value={'auto'}
                                                            onChange={e => {
                                                                if (edit) {
                                                                    setEditDemandTransporter({
                                                                        ...editDemandTransporter,
                                                                        bidType: e.target.value,
                                                                    });
                                                                }
                                                                setDemandTransporter({
                                                                    ...demandTransporter,
                                                                    bidType: e.target.value,
                                                                });
                                                            }}
                                                            checked={
                                                                edit
                                                                    ? editDemandTransporter.bidType == 'auto'
                                                                    : demandTransporter.bidType == 'auto'
                                                            }
                                                            disabled={statusCompleted == 'completed'}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                            Auto
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault2"
                                                            value={'manual'}
                                                            onChange={e => {
                                                                if (edit) {
                                                                    setEditDemandTransporter({
                                                                        ...editDemandTransporter,
                                                                        bidType: e.target.value,
                                                                    });
                                                                }
                                                                setDemandTransporter({
                                                                    ...demandTransporter,
                                                                    bidType: e.target.value,
                                                                });
                                                            }}
                                                            checked={
                                                                edit
                                                                    ? editDemandTransporter.bidType == 'manual'
                                                                    : demandTransporter.bidType == 'manual'
                                                            }
                                                            disabled={statusCompleted == 'completed'}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                            Manual
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <br></br>
                                        </>
                                    )}

                                    <div className="field_box">
                                        <h3>Pick Up & Delivery Details</h3>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <MultiSelect
                                                    isSingle={true}
                                                    options={locationData}
                                                    placeholder={'Select Pickup*'}
                                                    getMultiSelectValue={(e: any) => {
                                                        const pickLocId = demandTransporter?.fromLocationId || null;

                                                        try {
                                                            if (e?.value) {
                                                                // removeLocation(e?.value);
                                                                // if (pickLocId) {
                                                                //     handleLocationDataUpdate(pickLocId);
                                                                // }

                                                                getValue({ fromLocationId: e.value });
                                                                errors['fromLocationId']['error'] = false;
                                                                setError(errors);
                                                                handleLocationDataUpdate(e.value);
                                                            } else if (!e?.value && demandTransporter.fromLocationId) {
                                                                // handleLocationDataUpdate(pickLocId);
                                                                addLocation(pickLocId);
                                                                getValue({ fromLocationId: null });
                                                                errors['fromLocationId']['error'] = true;
                                                                setError(errors);
                                                            } else {
                                                                errors['fromLocationId']['error'] = true;
                                                                setError(errors);
                                                            }
                                                        } catch (error) {
                                                            ////////console.log('erorrrr', error);
                                                        }
                                                    }}
                                                    displayName="fullcity"
                                                    displayValue="id"
                                                    isDisabled={statusCompleted == 'completed'}
                                                    isClearable={edit ? false : true}
                                                    setSelectedValues={editDemandTransporter?.locationData || null}
                                                    notSelectDefault={true}
                                                />

                                                {errors?.fromLocationId?.required &&
                                                    errors?.fromLocationId?.error &&
                                                    isSubmit && (
                                                        <div className="text-danger ft-12 error-msg">
                                                            {' '}
                                                            {errors?.fromLocationId.message}
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <CustomDateTimePicker
                                                        data={{
                                                            name: 'cutOffTime',
                                                            placeholder: 'Select Cut Off Date and Time',
                                                            label: 'Cut Off Date',
                                                            type: 'datetime-local',
                                                            id: 'floatingInput',
                                                        }}
                                                        minDate={newDate24}
                                                        controlName="cutOffTime"
                                                        disabled={statusCompleted == 'completed'}
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.cutOffTime
                                                                : demandTransporter?.cutOffTime
                                                        }
                                                        setValue={(e: any) => {
                                                            demandTransporter['pickUpDate'] = null;
                                                            demandTransporter['deliveryDate'] = null;
                                                            setDemandTransporter(demandTransporter);
                                                            errors['pickUpDate']['error'] = true;
                                                            errors['deliveryDate']['error'] = true;
                                                            setError(errors);
                                                            getValue(e);
                                                        }}
                                                        errorMsg={errors?.cutOffTime.message}
                                                        inputProps={errors}
                                                        fromType={'demand'}
                                                        dtype={'demand_cutoff_date'}
                                                        closeOnSelect={true}
                                                        // filterPassedTime={filterPassedTime}
                                                        filterPassedTime={time => filterPassedTime(time, 'cutoff_date')}
                                                    />
                                                </div>
                                            </div>

                                            {edit ? (
                                                <>
                                                    {editDemandTransporter?.midLocationId?.length > 0 ? (
                                                        <>
                                                            {editDemandTransporter?.midLocationId.map((k, index) => (
                                                                <DemandAddMidLocation
                                                                    key={k.id}
                                                                    d={k}
                                                                    locationData={locationData}
                                                                    index={index}
                                                                    edit={edit}
                                                                    statusCompleted={statusCompleted}
                                                                    editDemandTransporter={editDemandTransporter}
                                                                    getValueMidLocation={(e, i, id) => {
                                                                        if (e?.value) {
                                                                            getValueMidLocation(e, i);
                                                                        } else if (!e?.value) {
                                                                            const pickLocId =
                                                                                editDemandTransporter?.midLocationId ||
                                                                                null;
                                                                            const findMidId = pickLocId?.find(
                                                                                data => data.id == id,
                                                                            );
                                                                            //console.log('findMidId add', findMidId);
                                                                            addLocation(findMidId?.value || null);
                                                                        }
                                                                    }}
                                                                    removeMultiSelect={(id, i) =>
                                                                        removeMultiSelect(id, i)
                                                                    }
                                                                    addMultiSelect={addMultiSelect}
                                                                    disbleAddBtn={
                                                                        statusCompleted == 'completed' ? true : false
                                                                    }
                                                                />
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col-sm-6">
                                                                <Button
                                                                    style={{ marginBottom: '30px' }}
                                                                    variant="secondary"
                                                                    size="sm"
                                                                    onClick={addMultiSelect}
                                                                >
                                                                    <IoMdAdd /> Add
                                                                </Button>
                                                            </div>
                                                            <div className="col-sm-6"></div>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                demandTransporter?.midLocationId?.length && (
                                                    <>
                                                        {demandTransporter?.midLocationId.map((k, index) => (
                                                            // <div className='row' key={k.id}>{JSON.stringify(k)}
                                                            <DemandAddMidLocation
                                                                key={k.id}
                                                                d={k}
                                                                locationData={locationData}
                                                                index={index}
                                                                edit={edit}
                                                                statusCompleted={statusCompleted}
                                                                editDemandTransporter={editDemandTransporter}
                                                                getValueMidLocation={(e, i, id) => {
                                                                    if (e?.value) {
                                                                        getValueMidLocation(e, i);
                                                                    } else if (!e?.value) {
                                                                        const pickLocId =
                                                                            demandTransporter?.midLocationId || null;
                                                                        const findMidId = pickLocId?.find(
                                                                            data => data.id == id,
                                                                        );
                                                                        addLocation(findMidId?.value || null);
                                                                    }
                                                                }}
                                                                removeMultiSelect={(id, i) => removeMultiSelect(id, i)}
                                                                addMultiSelect={addMultiSelect}
                                                                disbleAddBtn={false}
                                                            />
                                                            // </div>
                                                        ))}
                                                    </>
                                                )
                                            )}

                                            <div className="col-sm-6">
                                                <MultiSelect
                                                    isSingle={true}
                                                    options={locationData}
                                                    placeholder={'Select Drop*'}
                                                    getMultiSelectValue={(e: any) => {
                                                        const pickLocId = demandTransporter?.toLocationId || null;

                                                        if (e?.value) {
                                                            // if (pickLocId) {
                                                            //     handleLocationDataUpdate(pickLocId);
                                                            // }

                                                            getValue({ toLocationId: e.value });
                                                            errors['toLocationId']['error'] = false;
                                                            setError(errors);
                                                            handleLocationDataUpdate(e.value);
                                                        } else if (!e?.value && demandTransporter.toLocationId) {
                                                            // handleLocationDataUpdate(pickLocId);
                                                            addLocation(pickLocId);
                                                            getValue({ toLocationId: null });
                                                            errors['toLocationId']['error'] = true;
                                                            setError(errors);
                                                        } else {
                                                            errors['toLocationId']['error'] = true;
                                                            setError(errors);
                                                        }
                                                    }}
                                                    displayName="fullcity"
                                                    displayValue="id"
                                                    isClearable={edit ? false : true}
                                                    isDisabled={statusCompleted == 'completed'}
                                                    setSelectedValues={editDemandTransporter?.locationToData || null}
                                                    notSelectDefault={true}
                                                />

                                                {errors?.toLocationId?.required &&
                                                    errors?.toLocationId?.error &&
                                                    isSubmit && (
                                                        <div className="text-danger ft-12 error-msg">
                                                            {' '}
                                                            {errors?.toLocationId.message}
                                                        </div>
                                                    )}
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <CustomDateTimePicker
                                                        data={{
                                                            name: 'pickUpDate',
                                                            placeholder: 'Select Pickup Date and Time',
                                                            id: 'floatingInput',
                                                            label: 'Pickup Date',
                                                        }}
                                                        controlName="pickUpDate"
                                                        isSubmit={isSubmit}
                                                        disabled={statusCompleted == 'completed' || disabledPickup}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.pickUpDate
                                                                : demandTransporter?.pickUpDate
                                                        }
                                                        setValue={(e: any) => {
                                                            demandTransporter['deliveryDate'] = null;
                                                            setDemandTransporter(demandTransporter);
                                                            errors['deliveryDate']['error'] = true;
                                                            setError(errors);
                                                            getValue(e);
                                                        }}
                                                        errorMsg={errors?.pickUpDate.message}
                                                        inputProps={errors}
                                                        fromType={'demand'}
                                                        dtype={'demand_pickupdate'}
                                                        makeEmpty={true}
                                                        minDate={
                                                            edit
                                                                ? editDemandTransporter.cutOffTime
                                                                : demandTransporter.cutOffTime
                                                        }
                                                        selectDate={
                                                            edit
                                                                ? editDemandTransporter.cutOffTime
                                                                : demandTransporter.cutOffTime
                                                        }
                                                        closeOnSelect={true}
                                                        filterPassedTime={time => filterPassedTime(time, 'pickup_date')}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <MultiSelect
                                                        options={transporter}
                                                        placeholder={'Select Transporter*'}
                                                        getMultiSelectValue={getMultiSelectValue}
                                                        displayName="name"
                                                        displayValue="id"
                                                        isClearable={edit ? false : true}
                                                        isDisabled={statusCompleted == 'completed'}
                                                        notSelectDefault={true}
                                                        allSelectAll={edit ? false : true}
                                                        setSelectedValues={edit ? editDemandTransporter.userIds : null}
                                                    />
                                                    {errors?.userIds?.required &&
                                                        errors?.userIds?.error &&
                                                        isSubmit && (
                                                            <div className="text-danger ft-12 error-msg">
                                                                {errors?.userIds.message}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <CustomDateTimePicker
                                                        data={{
                                                            name: 'deliveryDate',
                                                            placeholder: 'Select Delivery Date and Time',
                                                            label: 'Delivery Date',
                                                            type: 'datetime-local',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="deliveryDate"
                                                        disabled={
                                                            statusCompleted == 'completed' || disabledDeliveryDate
                                                        }
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.deliveryDate
                                                                : demandTransporter?.deliveryDate
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.deliveryDate.message}
                                                        inputProps={errors}
                                                        fromType={'demand'}
                                                        dtype={'demand_delivery_date'}
                                                        makeEmpty={true}
                                                        selectDate={
                                                            edit
                                                                ? editDemandTransporter.pickUpDate
                                                                : demandTransporter.pickUpDate
                                                        }
                                                        minDate={
                                                            edit
                                                                ? editDemandTransporter.pickUpDate
                                                                : demandTransporter.pickUpDate
                                                        }
                                                        closeOnSelect={true}
                                                        filterPassedTime={time =>
                                                            filterPassedTime(time, 'delivery_date')
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="field_box">
                                        <h3>Additional Details</h3>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <DropDown
                                                    data={{
                                                        placeholder: 'Select Material',
                                                        name: 'material',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="materialType"
                                                    displayName={'name'}
                                                    optionValue={'key'}
                                                    isSubmit={isSubmit}
                                                    value={
                                                        edit
                                                            ? editDemandTransporter.materialType
                                                            : demandTransporter.materialType
                                                    }
                                                    options={materialData}
                                                    setValue={(e: any) => {
                                                        getValue(e);
                                                        setItemtype(e['materialType']);
                                                    }}
                                                    errorMsg={errors?.materialType.message}
                                                    inputProps={errors}
                                                    isDisabled={statusCompleted == 'completed'}
                                                />
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Weight',
                                                            name: 'weight',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="weight"
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.weight
                                                                : demandTransporter?.weight
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.weight.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                // (itemtype) &&

                                                <div className="col-sm-3">
                                                    <DropDown
                                                        data={{
                                                            placeholder: 'Select Unit',
                                                            name: 'unit',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="itemUnit"
                                                        displayName={'name'}
                                                        optionValue={'key'}
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter.itemUnit
                                                                : demandTransporter.itemUnit
                                                        }
                                                        options={unit}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.itemUnit.message}
                                                        inputProps={errors}
                                                        type={'unit'}
                                                        itemtype={itemtype}
                                                        isDisabled={statusCompleted == 'completed'}
                                                    />
                                                </div>
                                            }

                                            <div className="col-sm-12">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'number',
                                                            placeholder: 'No. of Vehicle Required',
                                                            name: 'noOfVehicles',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="noOfVehicles"
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.noOfVehicles
                                                                : demandTransporter?.noOfVehicles
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.noOfVehicles.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <h3 className="noMarginId">Bid Rate</h3>
                                                    <div className="form-check form-switch form-switch-lg ">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="isMaxAndMinOptional"
                                                            role="switch"
                                                            checked={
                                                                edit
                                                                    ? editDemandTransporter?.isMaxAndMinOptional
                                                                    : demandTransporter?.isMaxAndMinOptional
                                                            }
                                                            id="flexSwitchCheckDefault"
                                                            onChange={handleSwitch}
                                                            disabled={statusCompleted == 'completed'}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'number',
                                                            placeholder: 'Min Bid Rate (In Rs.)',
                                                            name: 'minBidRate',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="minBidRate"
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.isMaxAndMinOptional
                                                                    ? ''
                                                                    : editDemandTransporter?.minBidRate
                                                                : demandTransporter?.isMaxAndMinOptional
                                                                    ? ''
                                                                    : demandTransporter?.minBidRate
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.minBidRate.message}
                                                        readOnly={
                                                            editDemandTransporter?.isMaxAndMinOptional == true ||
                                                                isToggled == true
                                                                ? true
                                                                : false
                                                        }
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-4">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'number',
                                                            placeholder: 'Max Bid Rate (In Rs.)',
                                                            name: 'maxBidRate',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="maxBidRate"
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.isMaxAndMinOptional
                                                                    ? ''
                                                                    : editDemandTransporter?.maxBidRate
                                                                : demandTransporter?.isMaxAndMinOptional
                                                                    ? ''
                                                                    : demandTransporter?.maxBidRate
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.maxBidRate.message}
                                                        readOnly={
                                                            editDemandTransporter?.isMaxAndMinOptional == true ||
                                                                isToggled == true
                                                                ? true
                                                                : false
                                                        }
                                                        inputProps={errors}
                                                    />
                                                    {minBidError && isSubmit && (
                                                        <div
                                                            className="text-danger ft-12"
                                                            style={{ marginTop: '-30px' }}
                                                        >
                                                            {' '}
                                                            {'Max bid cannot be less then the min bid'}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Description',
                                                            name: 'description',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="description"
                                                        isSubmit={isSubmit}
                                                        value={
                                                            edit
                                                                ? editDemandTransporter?.description == 'null'
                                                                    ? ''
                                                                    : editDemandTransporter?.description
                                                                : demandTransporter?.description
                                                        }
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.description.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                {edit ? (
                                                    <>
                                                        {' '}
                                                        {editDemandTransporter?.imageUrl != null ? (
                                                            <>
                                                                {editDemandTransporter?.imageUrl == 'pdf' ? (
                                                                    <div className="previewpdf">
                                                                        <a
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            href={`${process.env.REACT_APP_API_BASE}${editDemandTransporter?.sampleId}`}
                                                                        >
                                                                            <img
                                                                                src="./assets/images/pdficon.svg"
                                                                                className="img-fluid"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                ) : (
                                                                    <div className="previewimage">
                                                                        <img
                                                                            src={editDemandTransporter?.imageUrl}
                                                                            className="img-fluid w-100 h-100"
                                                                        />
                                                                    </div>
                                                                )}
                                                                <br />
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <>
                                                            {' '}
                                                            {demandTransporter?.imageUrl != null ? (
                                                                <>
                                                                    {demandTransporter?.imageUrl == 'pdf' ? (
                                                                        <div className="previewpdf">
                                                                            <img
                                                                                src="./assets/images/pdficon.svg"
                                                                                className="img-fluid"
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="previewimage">
                                                                            <img
                                                                                src={demandTransporter?.imageUrl}
                                                                                className="img-fluid w-100 h-100"
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <br />
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    </>
                                                )}

                                                <div
                                                    className="drop-zone"
                                                    onClick={() => {
                                                        document.getElementById('drop')?.click();
                                                    }}
                                                >
                                                    <span className="drop-zone__prompt">
                                                        <span className="material-symbols-outlined">upload</span>{' '}
                                                        {edit
                                                            ? editDemandTransporter.sampleId
                                                                ? 'Update the document(Max size: 5MB)'
                                                                : 'Drop any attachment here'
                                                            : 'Drop any attachment here(Max size: 5MB)'}
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="myFile"
                                                        className="drop-zone__input"
                                                        id="drop"
                                                        accept=".jpeg, .jpg, .png, .pdf"
                                                        onChange={e => {
                                                            handlefile(e.target.files, e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {statusCompleted == 'completed' ? (
                            <></>
                        ) : (
                            <>
                                {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateDemand_transporter : addDemand_transporter}
                                        disabled={disableUpdateBtn}
                                    >
                                        {edit ? 'Update' : 'Add'}
                                    </Button>
                                ) : actionsPermissionValidator(location.pathname, ActionValues.Add) && !edit ? (
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateDemand_transporter : addDemand_transporter}
                                    // disabled={disableUpdateBtn}
                                    >
                                        {'Add'}
                                    </Button>
                                ) : (
                                    ''
                                )}

                                <Button
                                    variant="default"
                                    className="btn custom_btn border_btn with_icon"
                                    onClick={() => {
                                        handelModel(false);
                                        setEdit(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Modal.Footer>
                </Modal>
            )}


        </>
    );
}
